<template>
    <div>
        <div class="loader-class" v-if="isLoading">
            <ob-spinner loading-text="Loading..."></ob-spinner>
        </div>
        <div class="no-recrds-div" v-if="performanceReviews && performanceReviews.length == 0 && !isLoading">
            <img height="200px" width="200px"
                :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/No_Performace_Review.svg`" />
            <span class="no-recd-header">
                Performance evaluations haven’t been conducted yet.
            </span>
            <span class="no-recd-info">Evaluations will appear here once the process is initiated.</span>
        </div>
        <div v-if="performanceReviews && performanceReviews.length > 0 && !isLoading" class="col-md-12 per-rev-date">
            <div>
                <ob-input class="sear-class" icon="fa-search" placeholder="Search keyword"
                    v-model="searchText"></ob-input>
            </div>
            <div class="date-pic-hld">
                <ob-date-time-picker ref="startDate" class="offer-input" id="startdate" placeholder="From Date"
                    :inputvalue="fromDate" :options="datePickerOptions" v-model="fromDate"
                    @updated="(v) => fromDate = v" :dpchange="changeStartDate"></ob-date-time-picker>
                <ob-date-time-picker ref="endDate" class="offer-input" id="enddate" placeholder="To Date"
                    :inputvalue="toDate" :options="datePickerOptions" v-model="toDate"
                    @updated="(v) => toDate = v"></ob-date-time-picker>
                <div v-if="toDate || fromDate || (searchText && searchText.trim())" class="clr-filters">
                    <span @click="clearAllFilters">Clear</span>
                </div>
            </div>
        </div>
        <div v-if="filteredPerformanceReviews && filteredPerformanceReviews.length > 0 && !isLoading">
            <div class="col-md-12" v-for="(review, index) in filteredPerformanceReviews" :key="`performance-${index}`">
                <div class="col-md-12 review-card">
                    <div class="col-md-12 pL0 pR0 per-rev-date-r">
                        <div class="add-preference-title">
                            <img height="24px" width="24px"
                                :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/PM-Target_Arrow.svg`" />
                            <div class="pM-Card-name_card">
                                <div class="pM-Card-name_c"><span>{{
                                 review.ReviewStartDate === "" 
                                        ? review.BundleTitle 
                                        : review.BundleTitle + ' (' + getFormattedDate(review.ReviewStartDate) + ' - ' + getFormattedDate(review.ReviewEndDate) + ')'
                                    }}
                                    </span>
                                    <span
                                        v-if="review.Status == 'Pending' && calculateDaysDifference(review.ReviewEndDate, review.DueInDays) > 0"
                                        class="review-status">Due in {{ calculateDaysDifference(review.ReviewEndDate,
                                            review.DueInDays) }}
                                        day(s)</span>
                                </div>
                                <div class="create-Card-by"><img
                                        :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/PMS-User-Edit.svg`" /><span>{{
                                            review.CreatedByName }} on {{ getSubmittedDate(review.CreatedDateTime) }}</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <ob-button v-if="review.Status !== 'Completed' && isLoggedinuserMail(review)"
                                @click="fillForm(review)">Fill and Sign</ob-button>
                            <ob-button
                                v-if="review.Status !== 'Completed' && !isLoggedinuserMail(review) && !isLoggedinUserSigned(loggedInUserObj.email, review && review.SignerEmails ? review.SignerEmails : review.DocumentTemplate.SignerEmails)"
                                :disabled="true">Fill and Sign</ob-button>
                            <div class="actions-clsa" v-if="review.Status == 'Completed'">
                                <img @click="downloadDocument(review.SignRequestDocumentURL)"
                                    :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/PMS_Download.svg`" />
                                <ob-button type="secondary" @click="viewForm(review)">View</ob-button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 pL0 per-details">
                        <div class="col-md-12 status-header">
                            People assigned to complete this form
                        </div>
                        <div class="col-md-12" style="padding-left: 39px;">
                            <ol class="li-item">
                                <li class="signer-name" v-for="(signer, ind) in review.DocumentTemplate.SignerEmails"
                                    :key="`${review.Title}-${ind}`">
                                    <span> {{ signer.Name ? signer.Name : signer.Email }}<span>{{ loggedInUserObj.email
                                        == (signer && signer.Email ?
                                            signer.Email : '') ?
                                        ' (You)' : ' (' + (signer.Role == 'HRManager' ? formatText(signer.Role) :
                                            signer.Role) + ')' }}</span></span><span class="status-pill-yl"
                                        :style="{ 'background-color': signer.Status == 'Completed' ? '#B3EFB2' : signer.Status == 'Pending' ? '#FADCAA' : signer.Status == 'Viewed' ? '#90CAF9' : signer.Status == 'Cancelled' ? '#FECDD2' : '#FADCAA' }">{{
                                            signer.Status == 'Completed' ? `Submitted on
                                        ${getSubmittedDate(signer.SignedDateTime)}` : signer.Status ? signer.Status :
                                                'Pending' }}</span>
                                </li>
                            </ol>

                        </div>
                    </div>
                    <div class="col-md-12 pL0 signer-note"
                        v-if="review.Status !== 'Completed' && !isLoggedinuserMail(review) && !isLoggedinUserSigned(loggedInUserObj.email, review && review.SignerEmails ? review.SignerEmails : review.DocumentTemplate.SignerEmails)">
                        <img height="14px" width="14px"
                            :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/red_info_sign.svg`" />
                        <span>You cannot sign this document until the required signers have completed their
                            signatures.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import utils from '@/components/Core/utils.js'
export default {
    data() {
        return {
            searchText: '',
            fromDate: '',
            toDate: '',
            datePickerOptions: {
                format: 'MM/DD/YYYY'
            },
            performanceReviews: [],
            isLoading: false
        }
    },
    computed: {
        EmployeeID() {
            if (this.$route.query.EmployeeId) {
                return this.$route.query.EmployeeId
            }
            else
                return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
        },
        EmployeeEmail() {
            return this.loggedInUserObj.email
        },
        filteredPerformanceReviews() {
            const search = (this.searchText || '').trim().toLowerCase();

            const fromDate = this.fromDate ? new Date(this.fromDate) : null;
            const toDate = this.toDate ? new Date(this.toDate) : null;

            return this.performanceReviews.filter((review) => {
                const doc = review.DocumentTemplate || {};
                const signers = doc.SignerEmails || [];

                const reviewStart = review.ReviewStartDate ? new Date(review.ReviewStartDate) : null;
                const reviewEnd = review.ReviewEndDate ? new Date(review.ReviewEndDate) : null;

                const textMatch =
                    !search ||
                    (doc.DocumentName && doc.DocumentName.toLowerCase().includes(search)) ||
                    (review.BundleTitle && review.BundleTitle.toLowerCase().includes(search)) ||
                    signers.some((signer) =>
                        (signer.Name && signer.Name.toLowerCase().includes(search)) ||
                        (signer.Email && signer.Email.toLowerCase().includes(search))
                    );

                const dateMatch =
                    (!fromDate || (reviewStart && reviewStart >= fromDate)) &&
                    (!toDate || (reviewEnd && reviewEnd <= toDate));

                return textMatch && dateMatch;
            });

        },
        EmployeeOrgId() {
            return this.loggedInUserObj.orgId ? this.loggedInUserObj.orgId : '';
        }

    },
    created() {
        bus.listen("refreshPMStab", () => {
            this.getPerformanceReviews()
        })
        this.getPerformanceReviews()
    },
    methods: {
        getFormattedDate(date) {
            const input = new Date(date);

            const formatted = input.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            })
            return formatted;
        },
        changeStartDate(e) {
            this.$refs.endDate.data.minDate(e.date)
        },
        getPerformanceReviews() {
            this.isLoading = true
            ajax.get(`PerformanceManagement/GetByEmployeeId/${this.EmployeeID}?orgId=${this.EmployeeOrgId}`, {}, (res) => {
                this.isLoading = false
                if (res.data && res.data.State && res.data.Data && res.data.Data.length > 0) {
                    this.performanceReviews = res.data.Data
                }
                else {
                    this.performanceReviews = []
                    // this.$message({
                    //     type: 'error',
                    //     message: res.data.Message
                    // })
                }
            })
        },
        isLoggedinuserMail(data) {
            const isMatch = Object.prototype.hasOwnProperty.call(data.NextSignUrl, this.EmployeeEmail)
            return isMatch
        },
        fillForm(data) {
            var thisObj = this
            if (
                data.NextSignUrl &&
                Object.prototype.hasOwnProperty.call(data.NextSignUrl, this.EmployeeEmail)
            ) {
                const url = data.NextSignUrl[this.EmployeeEmail];
                const width = 1400;
                const height = 660;
                const left = (window.screen.width - width) / 2;
                const top = (window.screen.height - height) / 2;

                const win = window.open(url, '_blank');

                let intervalCount = 0;
                let isRequestCompleted = false;

                const interval = setInterval(() => {
                    if (intervalCount == 0)
                        thisObj.$loading({ loadingText: "Saving..." })

                    try {
                        if (
                            win != null &&
                            win.document &&
                            win.document.domain === document.domain &&
                            win.location.hostname === window.location.hostname
                        ) {
                            if (win.document.readyState === 'complete') {
                                isRequestCompleted = true;
                            }
                        }
                    } catch (e) { }

                    if (isRequestCompleted) {
                        setTimeout(() => {
                            thisObj.$loading({}).close()
                            this.getPerformanceReviews()
                            win.close();
                        }, 1500)
                        clearInterval(interval);
                    } else if (win.closed) {
                        setTimeout(() => {
                            thisObj.$loading({}).close()
                            this.getPerformanceReviews()
                            win.close();
                        }, 1500)
                        clearInterval(interval);
                    }

                    intervalCount++;
                }, 750);
            }
        },
        viewForm(data) {
            if (data && data.SignRequestDocumentURL) {
                window.open(data.SignRequestDocumentURL, '_blank')
            }
        },
        getSubmittedDate(dateStr) {
            const date = new Date(dateStr);
            return `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
                `${date.getDate().toString().padStart(2, '0')}/` +
                `${date.getFullYear()}`;
        },
        calculateDaysDifference(reviewEndDateStr, dueInDays) {
            const reviewEndDate = new Date(reviewEndDateStr); // parses MM/dd/yyyy
            const dueDate = new Date(reviewEndDate);
            dueDate.setDate(dueDate.getDate() + dueInDays);

            const today = new Date();
            // Clear time portion for accurate date comparison
            today.setHours(0, 0, 0, 0);
            dueDate.setHours(0, 0, 0, 0);

            const msPerDay = 1000 * 60 * 60 * 24;
            const diffInDays = Math.ceil((dueDate - today) / msPerDay);

            return diffInDays;
        },
        downloadDocument(url) {
            if (url) {
                this.$loading({ 'loadingText': 'Loading...' })
                utils.downloadSingleDoc(url)
                this.$loading({}).close()
            }
        },
        clearAllFilters() {
            this.toDate = ''
            this.fromDate = ''
            this.searchText = ''
        },
        isLoggedinUserSigned(loggedInEmail, signerEmails) {
            const signer = signerEmails.find(s => s.Email === loggedInEmail)
            if (!signer) return true

            return (
                signer.Status === 'Completed' &&
                !!signer.SignatureCertificate
            )
        },
        formatText(text) {
            return text.replace(/([A-Z])(?=[a-z])/g, ' $1').trim();
        }
    }
}
</script>
<style scoped>
.per-rev-date {
    display: flex;
    padding: 8px 16px;
    justify-content: space-between;
}

.date-pic-hld {
    display: flex;
    gap: 16px;
    align-items: center;
}

.per-rev-date-r {
    display: flex;
    justify-content: space-between;
}

.review-card {
    border-radius: 8px;
    padding: 24px;
    gap: 8px;
    border: 1px solid #BDBDBD;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 8px 0px;
}

.add-preference-title {
    display: flex;
    gap: 8px;
    align-items: center;
}

.pM-Card-name_card {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.pM-Card-name_c {
    display: flex;
    gap: 8px;
    align-items: center;

    span {
        color: #212121;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
    }
}

.review-status {
    background-color: #B00020;
    border-radius: 32px;
    padding: 4px 8px;
    color: #FFFFFF !important;
    font-weight: 400 !important;
    font-size: 12px;
    line-height: 14px;
}

.create-Card-by {
    color: #616161;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;

    img {
        height: 16px;
        width: 16px;
        margin-right: 4px;
    }
}

.per-details {
    border-radius: 8px;
    padding: 16px;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.signer-name {
    color: #212121;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
}

.status-header {
    color: #212121;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
}

.li-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.status-pill-yl {
    color: #212121;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    padding: 4px 8px;
    border-radius: 12px;
    margin-left: 8px;
}

.actions-clsa {
    display: flex;
    gap: 16px;
    align-items: center;

    img {
        cursor: pointer;
    }
}

.no-recrds-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 240px);
    gap: 12px;
    padding: 8px;
}

.no-recd-header {
    color: #212121;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
}

.no-recd-info {
    color: #616161;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
}

.clr-filters {
    color: #B00020;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
}

.signer-note {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
        color: #B00020;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/PerformanceReview/PerformanceReview.vue